/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { GetTile1$Params, getTile1 } from '../fn/map/get-tile-1';
import { Tile } from '../models/tile';

/**
 * Tile API
 */
@Injectable({ providedIn: 'root' })
export class MapService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getTile1()` */
   static readonly GetTile1Path = '/api/weather/map/tiles/{providerId}/{type}/{weatherType}/{date}/{z}/{x}/{y}';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getTile1()` instead.
    *
    * This method doesn't expect any request body.
    */
   getTile1$Response(params: GetTile1$Params, context?: HttpContext): Observable<StrictHttpResponse<Tile>> {
      return getTile1(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getTile1$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getTile1(params: GetTile1$Params, context?: HttpContext): Observable<Tile> {
      return this.getTile1$Response(params, context).pipe(map((r: StrictHttpResponse<Tile>): Tile => r.body));
   }
}
